import { useEffect } from 'react';

/**
 * Freezes background scrolling while a modal or sheet is open.
 *
 * On mobile this is not cosmetic: without it, a scroll gesture inside an open
 * sheet scrolls the page behind it, and on iOS the page can end up scrolled to a
 * position the user cannot get back from. The original overflow value is restored
 * so nested locks (sheet inside modal) do not leave the body stuck.
 */
export function useLockBodyScroll(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    const { body } = document;
    const previousOverflow = body.style.overflow;
    const previousPaddingRight = body.style.paddingRight;
    // Compensate for the scrollbar disappearing on desktop so content stays put.
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
    };
  }, [locked]);
}
